import { RegistryFieldType } from "../models/types";

export const customFieldTypeOptions: RegistryFieldType[] = [
  "Date",
  "Number",
  "String",
  "JSON",
  "User",
  "Asset",
  "Formatted Text",
  "String list",
  "Number with Unit",
  "User list",
  "Asset list",
  "Rating Level",
  "Monetary Value",
  "Boolean",
  "Percentage",
  "MLFlow Model",
  "MLFlow Data",
  "Evaluation Run",
  "Test Case",
  "Metric",
  "Role",
  "Workflow",
  "Action",
  "Evaluation Run list",
  "Test Case list",
  "Metric list",
  "Role list",
  "Workflow list",
  "Action list",
  "Tag",
  "Tag List",
  "IAM Policy",
  "IAM Policy list",
  "Task",
  "Task list",
  "Reference",
  "Reference list",
  "Integration",
  "Integration list",
  "Resource",
  "Resource list",
  "Parameter",
  "Parameter list",
  "Framework",
  "Framework list",
  "Element",
  "Element list",
  "Evidence",
  "Evidence list",
  "Hyperlink",
  "Image",
  "Report",
  "Questionnaire",
  "Metric Result",
  "Test Result",
  "Department",
  "Department list",
  "Impact Assessment",
  "Use Case",
  "Use Case list",
  "Risk Registry",
  "Name and Description",
  "Name and Description list",
  "Single Selection",
  "Text Area",
  "IA Stakeholder",
  "External Link",
  "Geographic Areas",
  "Languages",
  "Yes or No",
  "Potential Harm",
  "Data Origin",
  "Risk Level",
  "Relationship Complexity",
  "Vendor",
  "Jira Ticket",
  "Confluence Page",
  "Vendor Procurement Requirement",
  "File or Link",
  "Asset with Description list",
  "Metric with Description list",
  "Metric Result Test Result list",
  "Dataset list",
  "Model list",
  "Personal Information",
  "Multiple Selection",
  "Plugin Inference Table",
  "Color Scheme",
  "Metric Result list",
  "Connect Repositories",
  "Connect Models",
  "Documentation Upload",
  "Organization Setup",
  "User Information",
  "Co Workers And Role",
  "Organization Integrations",
  "Terms and Conditions",
  "Vendor Contact Information",
  "File Attachment List",
  "KPIs",
  "Collection list",
  "Single Dropdown",
  "Multiple Dropdown",
  "Base Model",
  "Policy",
  "Documentation",
  "Model",
  "Dataset",
  "Agent",
];
